import { render, staticRenderFns } from "./ordersList.vue?vue&type=template&id=ff4452ca&scoped=true&"
import script from "./ordersList.vue?vue&type=script&lang=js&"
export * from "./ordersList.vue?vue&type=script&lang=js&"
import style0 from "./ordersList.vue?vue&type=style&index=0&id=ff4452ca&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff4452ca",
  null
  
)

export default component.exports